export default __webpack_public_path__ + "static/media/008-interior design.ab53cba4.svg";